<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-row dense class="ma-2">
        <v-col cols="12" md="5">
          <v-card>
            <v-card-title>
              <span class="subtitle-1">
                {{ $t("DistributionCoverage.AlternativeDistrict") }}
              </span>
              <v-spacer />
              <v-btn
                small
                dark
                color="primary"
                class="px-2 me-2 mb-1"
                @click.stop="add()"
              >
                <v-icon x-small class="pe-1" color="white"
                  >fa-angle-double-right</v-icon
                >
                {{ $t("DistributionCoverage.Fields.addAll") }}
              </v-btn>
            </v-card-title>
            <v-data-table
              :headers="unselectHeaders"
              :items="districtsUnselect"
              :loading="loading"
              :search="unselectFilter"
              multi-sort
              class="elevation-2 px-4 py-1 mb-4"
              :footer-props="$t('$config.footer-props')"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                >
                  <v-row no-gutters class="me-n2 mx-n4">
                    <v-col cols="12" sm="9" md="8">
                      <v-text-field
                        v-model="unselectFilter"
                        clearable
                        hide-details
                        :label="$t('Search.filter')"
                      />
                    </v-col>
                    <v-spacer />
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:header.actions="{ header }">
                {{ header.text }}
                <v-icon x-small>fa-sliders-h</v-icon>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      v-bind="attrs"
                      v-on="on"
                      color="primary"
                      @click.stop="add(item)"
                      class="px-2 me-2 mb-1"
                    >
                      <v-icon x-small color="white">fa-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("DistributionCoverage.Fields.addHint") }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="12" md="7">
          <v-card>
            <v-card-title>
              <span class="subtitle-1">
                {{ $t("DistributionCoverage.SelectedDistrict") }}
              </span>
              <v-spacer />
              <v-btn
                    small
                    dark
                    color="danger"
                    class="px-2 me-2 mb-1"
                    @click.stop="remove()"
                  >
                    <v-icon x-small class="pe-1" color="white"
                      >fa-angle-double-left</v-icon
                    >
                    {{ $t("DistributionCoverage.Fields.removeAll") }}
                  </v-btn>
            </v-card-title>
          <v-data-table
            :headers="selectedHeaders"
            :items="districtsSelected"
            :loading="loading"
            :search="selectedFilter"
            multi-sort
            class="elevation-2 px-4 py-1 mb-4"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <v-row no-gutters class="me-n2 mx-n4">
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="selectedFilter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                  <v-spacer />
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.count_invalid="{ item }">
              <v-chip
                small
                label
                color="warning"
                text-color="white"
                @click.stop="
                  $router.push({
                    path: '/stocks/distribution-coverage/invalid-materials',
                    query: {
                      stock_id: stockId,
                      district_code: item.district_code,
                    },
                  })
                "
              >
                {{
                  $t("DistributionCoverage.Fields.exclude_materials", [
                    item.count_invalid,
                  ])
                }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    @click.stop="remove(false, item)"
                    class="px-2 me-2 mb-1"
                  >
                    <v-icon x-small color="white">fa-minus</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("DistributionCoverage.Fields.removeHint") }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>

    <v-dialog v-model="conflictDialog" width="800px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("CRUD.info", [$t("$vuetify.alert")]) }}
          <v-spacer />
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="conflictDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>{{ $t("$vuetify.close") }}</span>
          </v-tooltip>
        </v-card-title>
        <v-row dense>
          <span class="caption mx-10 danger--text font-weight-bold">
            {{ $t("DistributionCoverage.districtConflictDialogMsg") }}
          </span>
        </v-row>
        <v-data-table
          :headers="conflictHeaders"
          :items="conflictMaterials"
          :loading="loading"
          multi-sort
          class="elevation-0 px-6"
          v-resize="resizeHeader"
          :footer-props="footerProps"
        >
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            class="elevation-1"
            @click="conflictDialog = false"
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogAlert
      v-model="confirmRemoveDialog"
      :message="confirmRemoveMsg"
      useConfirm
      @confirm="
        remove(true, []);
        confirmRemoveDialog = false;
      "
      @cancel="
        removeData = []
      "
    />
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs";
import Stocks from "@/api/stocks";
import DistributionCoverage from "@/api/distribution_coverage";
import DialogAlert from "@/components/plugins/DialogAlert";

export default {
  components: {
    Breadcrumbs,
    DialogAlert,
  },

  computed: {
    stockId() {
      return this.stock ? this.stock.id : 0;
    },
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stocks"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.distributionCoverage"),
          disabled: true,
          href: "/stocks/distribution-coverage",
        },
        {
          text: this.stock && this.stock.name ? this.stock.name : "",
          accent: true,
          disabled: false,
        },
      ];
    },

    unselectHeaders: () => [
      {
        text: i18n.t("DistributionCoverage.Fields.code"),
        align: "start",
        sortable: false,
        value: "number",
      },
      {
        text: i18n.t("DistributionCoverage.Fields.name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    selectedHeaders: () => [
      {
        text: i18n.t("DistributionCoverage.Fields.code"),
        align: "start",
        sortable: false,
        value: "district_number",
      },
      {
        text: i18n.t("DistributionCoverage.Fields.name"),
        align: "start",
        sortable: false,
        value: "district_name",
      },
      {
        text: i18n.t("DistributionCoverage.Fields.status"),
        align: "center",
        sortable: false,
        value: "count_invalid",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    conflictHeaders: () => [
      {
        text: i18n.t("DistributionCoverage.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("DistributionCoverage.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("DistributionCoverage.Fields.name"),
        align: "start",
        sortable: false,
        value: "district_name",
      },
      {
        text: i18n.t("DistributionCoverage.Fields.distribution_center_name"),
        align: "center",
        sortable: false,
        value: "distribution_center_name",
      },
    ],

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    stock: {},
    unselectFilter: "",
    selectedFilter: "",
    districtsUnselect: [],
    districtsSelected: [],
    conflictMaterials: [],
    conflictDialog: false,
    itemsPerPageOptions: 10,
    confirmRemoveDialog: false,
    confirmRemoveMsg: "",
    removeData: [],
  }),

  mounted() {
    if (this.$route.query.stock_id) {
      Stocks.fetchOne(this.$route.query.stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock = response.data.stock;
          }
        }.bind(this)
      );
    }
  },

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },

    getDistricts() {
      // 获取备选分组列表
      DistributionCoverage.fetchUnselect({ stock_id: this.stockId }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.districtsUnselect = response.data.districts;
          }
        }.bind(this)
      );
      // 获取已绑定的分组
      DistributionCoverage.fetchSelected({ stock_id: this.stockId }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.districtsSelected = response.data.districts;
          }
        }.bind(this)
      );
    },
    //添加分组
    add(district) {
      DistributionCoverage.add(
        district
          ? {
              district_code: district.code,
              stock_id: this.stockId,
            }
          : {
              stock_id: this.stockId,
            }
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getDistricts();
            if (response.data.conflicts.length) {
              this.conflictMaterials = response.data.conflicts;
              this.conflictDialog = true;
            }
          }
        }.bind(this)
      );
    },
    //移除分组
    remove(isConfirm, district) {
      if (isConfirm) {
        this.removeData.delivery_remove = 1
      } else {
        this.removeData = district
          ? {
            district_code: district.district_code,
            stock_id: this.stockId,
          }
          : {
            stock_id: this.stockId,
          }
      }
      DistributionCoverage.remove(this.removeData).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.removeData = [];
            this.confirmRemoveMsg = "";
            this.getDistricts();
          } else if (response.data.error.code == "ERR490") {
            this.confirmRemoveMsg = response.data.error.msg;
            this.confirmRemoveDialog = true;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    stock: {
      handler() {
        if (this.stock && this.stock.id) {
          this.getDistricts();
        }
      },
    },
    conflictDialog: {
      deep: true,
      handler() {
        if (!this.conflictDialog && this.conflictMaterials.length) {
          this.conflictMaterials = [];
        }
      },
    },
  },
};
</script>